// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const headerBarHeight = 80;

let currRole = "";
let currUser = [];
let currUserOrg = [];

export const currentUserRole = currRole;
export const currentUserOrg = currUserOrg;
export const currentUser = currUser;
